import { Subject } from "rxjs";

const subject = new Subject();
const DefaultErrorMessage =
  "An unexpected error has occurred. Please try again. Contact us at support@debtonator.us if the problem continues.";

export const notificationService = {
  sendMessage: (message, type, heading, autoDismiss) =>
    subject.next({
      message: message,
      type: type,
      heading: heading,
      autoDismiss,
    }),
  clearMessages: () => subject.next(),
  getMessage: () => subject.asObservable(),
  sendErrorMessage: (message = DefaultErrorMessage) =>
    subject.next({ message: message, type: "danger", heading: "Error" }),
  sendSuccessMessage: (message) =>
    subject.next({ message: message, type: "success", heading: "Success" }),
  sendInfoMessage: (message) =>
    subject.next({ message: message, type: "info", heading: "Info" }),
};
